

































import { MButton, MLink, MMessage } from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";

@Component({ components: { MButton, MMessage, MLink } })
export default class Accueil extends Vue {
  private connexion(): void {
    this.$msal.login();
  }
}
